export const OrganizationDbLogsMockData = [
  {
    id: '99fd3a2b-ca3d-ee11-b638-2c6dc19c19d5',
    createdOn: '2023-08-18T13:21:42.2828217+00:00',
    createdBy: '3c59cbfb-c68b-eb11-b566-000d3a2238b1',
    userName: 'user1@testemail.org',
    success: false,
  },
  {
    id: '5f6fda46-d032-ee11-b632-2c6dc19c19d5',
    createdOn: '2023-08-04T14:07:42.7602539+00:00',
    createdBy: '3c59cbfb-c68b-eb11-b566-000d3a2238b1',
    userName: 'user2@testemail.org',
    success: true,
  },
] as any[];
